import type { ReactNode } from "react";

/** Kept as the app-level boundary so providers do not need to be reordered.
 * The console now has one intentional light palette, inlined before paint. */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
